module.exports = __webpack_public_path__ + "img/collection-engagementRingsFancy@2x.bf15682.jpg";